<template>
  <div class="py-3">
    <div class="bg-white">
      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información Adicional
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-5 mb-3">
              <p class="font-14 text-muted mb-1">
                Razón:
              </p>
              <p class="font-16">
                {{ item?.reason | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-6 mb-3">
              <p class="font-14 text-muted mb-1">
                Sometido Por:
              </p>
              <p class="font-16">
                {{ item?.user?.name | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdditionalInfo',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
</style>
